// extracted by mini-css-extract-plugin
export default {"upsellWrapper":"KU","backgroundimage":"LU","header":"MU","headerwrap":"NU","title":"OU","promomessage":"PU","upsellItem":"QU","upsellImg":"RU","helperText":"SU","upsellHeadline":"TU","price":"UU","upsellGross":"VU","upsellNet":"WU","upsellButton":"XU","nutritionfacts":"YU","nutritionimg":"ZU","containerwhy":"aV","nutritionwrappwer":"bV","headlinewhy":"cV","boxwhy":"eV","textwhy":"fV","backbutton":"gV","drawercontainer":"hV","logoheader":"iV","textwrap":"jV","timer":"kV"};
    if(module.hot) {
      // 1730991512294
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  